/** @jsxImportSource @emotion/react */
import React,{ useMemo } from 'react';
import tw, { styled } from 'twin.macro';

import useWorkshop from '../../hooks/useWorkshopMorale';
import useLocalization from '../../hooks/useLocalization';

const TotalRevenue = () => {
  const { scheduleData } = useWorkshop();
  const { t } = useLocalization();
  const total = useMemo(() => {
    let temp = 0;
    scheduleData.forEach((item) => {
      temp += item.total
    })
    return temp;
  },[scheduleData])


  return (<TotalRevenueWrapper>{t(`estimatedTotalRevenue`)}：{total}</TotalRevenueWrapper>);
}

export default TotalRevenue;

const TotalRevenueWrapper = styled.div`
  ${tw`
    rounded
    text-black
    bg-white
    z-50
    h-[40px]
    leading-[40px]
    px-3
    w-[266px]
    absolute
    left-6
    top-[-70px]
  `}
  box-shadow: 0px 2px 4px -1px rgb(0 0 0 / 20%), 0px 4px 5px 0px rgb(0 0 0 / 14%), 0px 1px 10px 0px rgb(0 0 0 / 12%);
`